import React, { useState, useEffect, useContext } from "react"

import { Select, Popconfirm, Table, Input, DatePicker, Spin, Modal } from "antd"
import { ArrowLeft } from "lucide-react"
import { fetchActiveDeductionTypes } from "../../service/deductionTypeService"
import {
  createDeduction,
  fetchDeductioDetails,
  editDeduction,
  deleteDeduction,
  fetchSearchDeduction,
} from "../../service/deductionService"
import BulkUploadModal from "../../feature-module/hrm/deductionBulkUpload"
import dayjs from "dayjs"
import { Link } from "react-router-dom"
import TextArea from "antd/es/input/TextArea"
import { getAllActiveEmployees } from "../../service/employeeService"
import moment from "moment"
import Swal from "sweetalert2"
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";  
import * as XLSX from 'xlsx';


const Deduction = () => {
  const { user } = useContext(UserContext);
  const [deductionTypeList, setDeductionTypeList] = useState()
  const [deductionList, setDeductionList] = useState([])
  const [selectedEmp, setSelectedEmp] = useState()
  const [empList, setEmpList] = useState([])
  const [type, setType] = useState()
  const [amount, setAmount] = useState()
  const [description, setDescription] = useState()
  const [paymentTyep, setPaymentType] = useState("oneTime")
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [paymentPeriod, setPaymentPeriod] = useState()
  const [installement, setInstallement] = useState()
  const [effectiveDate, setEffectiveDate] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [record, setRecord] = useState(false)
  const [effectiveDateError, setEffectiveDateError] = useState("")
  const [dateValidationError, setDateValidationError] = useState("")
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)
  const [epf_number, setEpf] = useState("")
  const [deductionType, setdeductionType] = useState("")
  const [searchDate, setSearchDate] = useState(null)
  const [name, setName] = useState("")
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 })
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
  const pageSizeOptions = [5, 10, 20, 50, 100]
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)

  const handleSearchDateChange = (date, dateString) => {
    setSearchDate(dateString)
    if (searchDate) {
      console.log(searchDate)
    }
  }

  const fetchTypeData = async () => {
    const data = await fetchActiveDeductionTypes()
    setDeductionTypeList(data.data.deduction)
  }

  const fetchData = async () => {
    const data = await fetchDeductioDetails({})
    setDeductionList(data.data.deduction)
    const empList = await getAllActiveEmployees()
    setEmpList(empList.data)
  }

  useEffect(() => {
    setLoading2(true)
    const handler = setTimeout(() => {
      fetchTypeData()
      fetchData()
      setLoading2(false)
    }, 400)
    return () => {
      clearTimeout(handler)
    }
  }, [])

  // Function to disable dates before the cutoff in the calendar
  const disabledEffectiveDate = (current) => {
    if (!current) {
      return false
    }

    const today = dayjs()
    
    // Calculate the 20th of the previous salary cycle as the cutoff
    let cutoffDate
    
    if (today.date() >= 19) {
      cutoffDate = today.date(20)
    } else {
      cutoffDate = today.subtract(1, 'month').date(20)
    }

    // Disable dates before the cutoff
    return current.isBefore(cutoffDate, 'day')
  }

  // Validate Effective Date - must not be earlier than 20th of previous salary cycle
  const validateEffectiveDate = (date) => {
    if (!date) {
      setEffectiveDateError("Effective date is required")
      return false
    }

    const selectedDate = dayjs(date)
    const today = dayjs()
    
    // Salary cycle definition: 19th to 18th of next month
    // Example: Jan 19 - Feb 18 = January salary
    //          Feb 19 - Mar 18 = February salary
    
    // Calculate the 20th of the previous salary cycle as the cutoff
    let cutoffDate
    
    if (today.date() >= 19) {
      // We are in the current salary cycle (19th onwards)
      // Current cycle: 19th of this month to 18th of next month
      // Previous cycle ended on 18th of this month
      // So cutoff is 20th of this month (2 days after previous cycle ended)
      cutoffDate = today.date(20)
    } else {
      // We are before the 19th, so we're in the tail end of previous month's cycle
      // Current cycle: 19th of last month to 18th of this month
      // Previous cycle ended on 18th of last month
      // So cutoff is 20th of last month
      cutoffDate = today.subtract(1, 'month').date(20)
    }

    // Check if selected date is before the cutoff
    if (selectedDate.isBefore(cutoffDate, 'day')) {
      setEffectiveDateError(
        `Effective date must be on or after ${cutoffDate.format('YYYY-MM-DD')} (20th of the previous salary cycle)`
      )
      return false
    }

    // Future dates are allowed - no upper limit restriction
    setEffectiveDateError("")
    return true
  }

  // Validate date ranges for recurring deductions
  const validateDateRange = () => {
    if (paymentTyep === "recurring") {
      if (!startDate || !endDate) {
        setDateValidationError("Start Date and End Date are required for recurring deductions")
        return false
      }
      
      if (dayjs(startDate).isAfter(dayjs(endDate)) || dayjs(startDate).isSame(dayjs(endDate))) {
        setDateValidationError("Start Date must be before End Date")
        return false
      }
    }
    setDateValidationError("")
    return true
  }

  // Auto-calculate installment amount for recurring deductions
  const calculateInstallment = () => {
    if (paymentTyep === "recurring" && amount && paymentPeriod && paymentPeriod > 0) {
      const calculatedInstallment = parseFloat(amount) / parseFloat(paymentPeriod)
      setInstallement(calculatedInstallment.toFixed(2))
    }
  }

  // Effect to auto-calculate installment when amount or payment period changes
  useEffect(() => {
    if (paymentTyep === "recurring") {
      calculateInstallment()
    }
  }, [amount, paymentPeriod, paymentTyep])

  const editData = (record) => {
    setIsEdit(true)
    // console.log("edit",record)
    setType(record.parentId?._id || null)
    setAmount(record.amount)
    setDescription(record.description)
    setPaymentType(record.paymentType || "oneTime")
    setStartDate(record.startDate ? dayjs(record.startDate) : null)
    setEndDate(record.endDate ? dayjs(record.endDate) : null)
    setPaymentPeriod(record.paymentPeriod)
    setInstallement(record.installement)
    setEffectiveDate(record.deduction_date ? dayjs(record.deduction_date) : null)
    setRecord(record)
    setEffectiveDateError("")
    setDateValidationError("")

    setSelectedEmp(record.employee?._id || null)
  }

  const deleteData = async (record) => {
    await deleteDeduction({ id: record._id })
    setLoading2(true)

    setTimeout(() => {
      fetchData()
      setLoading2(false)
    }, 400)
  }
  const getSeachDeductions = async () => {
    const records = await fetchSearchDeduction({
      setLoading2,
      epf_number,
      name,
      deductionType,
      date: searchDate,
    })
    console.log(records, "FETCHED DATA")
    if (records) {
      setDeductionList(records)
    } else {
      setDeductionList([]) // Ensure fallback to an empty array
    }
    //console.log(deductionList,"this is record")
  }
  const handleExcelExport = () => {
    // Prepare data for export
    const exportData = deductionList.map(item => ({
      "EPF Number": item.employee?.epf_number || 'N/A',
      "Employee ID": item.employee?.employee_id || 'N/A',
      "Employee Name": item.employee ? (item.employee.full_name || `${item.employee.first_name} ${item.employee.last_name}`) : 'N/A',
      "Deduction Type": item.parentId?.deducitionType || 'N/A',
      "Amount (Rs.)": item.amount?.toFixed(2) || '0.00',
      "Payment Type": item.paymentType === "oneTime" ? "One Time" : "Recurring",
      "Description": item.description || 'N/A',
      "Start Date": item.startDate ? moment(item.startDate).format("YYYY-MM-DD") : 'N/A',
      "End Date": item.endDate ? moment(item.endDate).format("YYYY-MM-DD") : 'N/A',
      "Payment Period": item.paymentPeriod || 'N/A',
      "Installment Amount (Rs.)": item.installement?.toFixed(2) || '0.00',
      "Effective Date": item.deduction_date || 'N/A'
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);
    
    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Deductions");
    
    // Generate file name with current date
    const fileName = `Deductions_Report_${moment().format('YYYY-MM-DD')}.xlsx`;
    
    // Export the file
    XLSX.writeFile(wb, fileName);
  };


  const columns = [
    {
      title: "Employee",
      dataIndex: "employee",
      key: "employee",
      render: (employee) =>
        employee 
          ? `${employee.epf_number || employee.employee_id} - ${employee.full_name || employee.first_name + " " + employee.last_name}` 
          : "No Employee Info",
    },
    {
      title: "Deduction(Rs)",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => (amount !== null && amount !== undefined ? `${amount.toFixed(2)}` : "Rs. 0.00"), // Default if the amount is null or undefined
    },
    {
      title: "Deduction Type",
      dataIndex: "paymentType",
      key: "paymentType",
      render: (paymentTyep) =>
        paymentTyep === "oneTime" ? (
          <span className="badge bg-primary">One Time</span>
        ) : (
          <span className="badge bg-success">Recurring</span>
        ),
    },
    {
      title: "Reason",
      dataIndex: "parentId",
      key: "parentId",
      render: (parentId) => (parentId ? `${parentId.deducitionType}` : "No Deduction Info"),
    },
    {
      title: "Effective Date",
      dataIndex: "deduction_date",
      key: "deduction_date",
      render: (deduction_date) => deduction_date ? moment(deduction_date).format("YYYY-MM-DD") : "N/A",
    },

    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (startDate) => moment(startDate).format("YYYY-MM-DD"),
    },

    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (endDate) => moment(endDate).format("YYYY-MM-DD"),
    },

    {
      title: "Payment Terms",
      dataIndex: "paymentPeriod",
      key: "paymentPeriod",
    },

    {
      title: "Installment(Rs)",
      dataIndex: "installement",
      key: "installement",
      render: (installement) =>
        installement !== null && installement !== undefined ? `${installement.toFixed(2)}` : "0.00", // Default if the amount is null or undefined
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
                                          {user?.permissions && hasPermission(user.permissions, "HRM", "Deductions", "edit") && (

          <Link
            className="me-2 p-2"
            to="#"
            onClick={() => {
              editData(record)
            }}
          >
            <i data-feather="download" className="feather-edit"></i>
          </Link> )}
          {user?.permissions && hasPermission(user.permissions, "HRM", "Deductions", "delete") && (

          <Popconfirm
            title="Delete the Department"
            description="Are you sure to delete this Department?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              deleteData(record)
            }}
            onCancel={() => {
              console.log("c")
            }}
          >
            <Link className="confirm-text p-2" to="#">
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </Popconfirm>)}
        </td>
      ),
    },
  ]

  const handleDateStart = (date) => {
    setStartDate(date)
  }

  const handleDateEnd = (date) => {
    setEndDate(date)
  }

  const handleSave = async () => {
    // Basic validation
    if (!selectedEmp || !type || !amount) {
      Swal.fire("Error", "Please fill in Employee, Deduction Category, and Amount", "error")
      return
    }

    // Validate effective date
    if (!validateEffectiveDate(effectiveDate)) {
      Swal.fire("Error", effectiveDateError || "Invalid effective date", "error")
      return
    }

    // Validate based on payment type
    if (paymentTyep === "recurring") {
      // Recurring deduction validations
      if (!startDate || !endDate) {
        Swal.fire("Error", "Start Date and End Date are required for recurring deductions", "error")
        return
      }

      if (!paymentPeriod || paymentPeriod <= 0) {
        Swal.fire("Error", "Number of Installments must be greater than 0", "error")
        return
      }

      if (!validateDateRange()) {
        Swal.fire("Error", dateValidationError || "Invalid date range", "error")
        return
      }
    }

    if (isEdit) {
      const obj = {
        employee: selectedEmp,
        parentId: type,
        amount: amount,
        description: description,
        paymentPeriod: paymentTyep === "recurring" ? paymentPeriod : 1,
        installement: paymentTyep === "recurring" ? installement : amount,
        paymentType: paymentTyep,
        startDate: paymentTyep === "recurring" ? startDate : effectiveDate,
        endDate: paymentTyep === "recurring" ? endDate : effectiveDate,
        deduction_date: effectiveDate ? dayjs(effectiveDate).format("YYYY-MM-DD") : null,
      }
      setLoading(true)
      await editDeduction(record._id, obj)
      setLoading(false)
      handleReset()
      Swal.fire("Success", "Deduction updated successfully", "success")
    } else {
      const obj = {
        employee: selectedEmp,
        parentId: type,
        amount: amount,
        description: description,
        paymentPeriod: paymentTyep === "recurring" ? paymentPeriod : 1,
        installement: paymentTyep === "recurring" ? installement : amount,
        paymentType: paymentTyep,
        startDate: paymentTyep === "recurring" ? startDate : effectiveDate,
        endDate: paymentTyep === "recurring" ? endDate : effectiveDate,
        deduction_date: effectiveDate ? dayjs(effectiveDate).format("YYYY-MM-DD") : null,
      }
      setLoading(true)
      await createDeduction(obj)
      setLoading(false)
      handleReset()
      Swal.fire("Success", "Deduction created successfully", "success")
    }
    setLoading2(true)

    setTimeout(() => {
      fetchData()
      setLoading2(false)
    }, 500)
  }
  const handleReset = () => {
    setType(null)
    setAmount()
    setDescription()
    setPaymentType("oneTime")
    setStartDate()
    setEndDate()
    setPaymentPeriod()
    setInstallement()
    setEffectiveDate(null)
    setIsEdit(false)
    setEffectiveDateError("")
    setDateValidationError("")
    setSelectedEmp(null)
  }

  const setTypeAsTyep = (value) => {
    setType(value)
  }

  // const optionsWithDisabled = [
  //     { label: 'Reoccurring', value: 'Reoccurring' },
  //     { label: 'One Time', value: 'One Time' },
  // ];
  //
  const onchangePaymentType = (e) => {
    const newType = e.target.value
    setPaymentType(newType)
    
    // Clear validation errors when switching payment types
    setDateValidationError("")
    
    // Clear recurring-specific fields when switching to one-time
    if (newType === "oneTime") {
      setStartDate(null)
      setEndDate(null)
      setPaymentPeriod(null)
      setInstallement(null)
    }
  }

  const handleTableChange = (pagination) => {
    setPagination(pagination)
  }

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }

  //console.log("EMP LIST",empList)
  return (
    <div>
      <div className="page-wrapper-lt">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="header-leave-container ">
                <div>
                  <ArrowLeft size={32} />
                </div>

                <div className="page-title">
                  <h4>Deduction</h4>
                  <h6>Manage Deduction</h6>
                </div>
              </div>
             <div className="wordset">
                           <ul>
                             {" "}
                             <li>
              <a
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="excel"
                      onClick={handleExcelExport}
                    >
                      <img src="assets/img/icons/excel.svg" alt="excel" />
                    </a></li></ul></div>

              <div className="page-btn">
  <a 
    className={`btn btn-added ${hasPermission(user?.permissions, "HRM", "Deductions", "upload") ? '' : 'disabled'}`}
    onClick={() => {
      if (hasPermission(user?.permissions, "HRM", "Deductions", "upload")) {
        setIsBulkUploadOpen(true);
      }
    }}
    title={!hasPermission(user?.permissions, "HRM", "Deductions", "upload") ? "You don't have permission to upload" : ""}
  >
    Bulk upload
  </a>
</div>
            </div>
          </div>
          <div className="card table-list-card-leave">
            <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
              <div
                className="container mt-3 "
                style={{
                  maxWidth: "100%",
                  marginLeft: "20px",
                  marginRight: "40px",
                }}
              >
                {" "}
                {/* Added p-0 and maxWidth */}
                <div className="row d-flex flex-wrap align-items-start justify-content-between">
                  {" "}
                  {/* Added justify-content-start */}
                  <div className="col-12 col-md-3  text-start">
                    <label className="form-label">Employee Name</label>
                    <input
                      type="text"
                      value={name}
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only letters and spaces
                        if (value === '' || /^[a-zA-Z\s]+$/.test(value)) {
                          setName(value);
                        }
                      }}
                      style={{ width: "100%", height: "38px" }}
                      placeholder="Enter name (letters only)"
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-3 text-start">
                    <label className="form-label">EPF No</label>
                    <input
                      className="form-control"
                      type="text"
                      value={epf_number}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setEpf(value);
                      }}
                      style={{ width: "100%", height: "38px" }}
                      placeholder="Enter EPF (digits only)"
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-3 text-start">
                    <label className="form-label">Deduction Type</label>
                    <input
                      className="form-control"
                      type="text"
                      value={deductionType}
                      onChange={(e) => setdeductionType(e.target.value)}
                      style={{ width: "100%", height: "38px" }}
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-3 text-start">
                    <label className="form-label">Date</label>
                    <DatePicker
                      picker="month"
                      //defaultValue={dayjs()}
                      format="YYYY-MM" // Display the year and month in the desired format
                      style={{ width: "100%", height: "38px" }}
                      onChange={handleSearchDateChange}
                      placeholder="Select Date"
                    />
                  </div>
                </div>
              </div>

              <div
                className="container mt-0"
                style={{
                  maxWidth: "100%",
                  marginLeft: "20px",
                  marginRight: "40px",
                }}
              >
                <div className="row d-flex align-items-center justify-content-start">
                  {/* Center Select */}
                  {/* <div className="col-12 col-md-2 mb-3 text-start">
                                    <label className="form-label">Year</label>
                                    <div className="d-flex align-items-center">
                                    <DatePicker
                                        picker="year"
                                        onChange={handleSearchYearChange}
                                        //defaultValue={dayjs(`${currentYear}`, 'YYYY')}
                                        placeholder="Select Year"
                                        size="large"
                                        style={{ width: "100%", borderRadius: 8 }}
                                        allowClear
                                    />
                                    </div>
                                </div> */}

                  {/* Search Button */}
                  {/* <div className="col-12 col-md-2 mb-3 text-start">
                                    <label className="form-label" style={{ visibility: "hidden" }}>Hidden Label</label>
                                    <div className="d-flex align-items-center">
                                        <button
                                            className="btn btn-submit"
                                            onClick={handleSearch}
                                            style={{ height: "38px", width: "55%" }}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div> */}
                  <div className="col-12 col-md-2 mb-3 text-start">
                    <button
                      disabled={loading || loading2}
                      className="btn btn-submit"
                      onClick={getSeachDeductions}
                      style={{ height: "38px", width: "55%" }}
                    >
                      {loading || loading2 ? "Search " : "Search"}
                    </button>
                    {loading || loading2 ? (
                      <div className="spinner">
                        <div className="loading-circle"></div>
                      </div>
                    ) : (
                      <div>{/* Render Data Here */}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row row1">
            <div className="col-3 col-d">
              <div className="card" style={{ backgroundColor: "#eeeeeeea" }}>
                <div className="card-body">
                  <div className="input-blocks">
                    <label htmlFor="jobTypeName">Employee</label>
                    <Select
                      showSearch
                      style={{
                        width: "100%",
                      }}
                      size={"large"}
                      onChange={(e) => setSelectedEmp(e)}
                      placeholder="Select Employee"
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "").toLowerCase().localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      value={selectedEmp}
                      options={(empList || []).map((d) => ({
                        value: d._id,
                        label: d.epf_number 
                          ? `${d.epf_number} - ${d.full_name || d.first_name + " " + d.last_name}`
                          : `N/A - ${d.full_name || d.first_name + " " + d.last_name}`,
                      }))}
                    />
                  </div>
                  <div className="input-blocks">
                    <label htmlFor="jobTypeName">Deduction Category</label>
                    <Select
                      size="large"
                      name="type"
                      className="select"
                      options={deductionTypeList?.map((val) => ({
                        value: val._id,
                        label: val.deducitionType,
                      }))}
                      value={type}
                      onChange={(e) => setTypeAsTyep(e)}
                      placeholder="Select Deduction Category"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="input-blocks">
                    <label className="form-label">Amount (Rs.)</label>
                    <Input
                      size="large"
                      placeholder="00.00"
                      value={amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only numbers and decimal point
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          setAmount(value);
                        }
                      }}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="input-blocks">
                    <label className="form-label">
                      Effective Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <DatePicker
                      size="large"
                      placeholder="Select Effective Date"
                      value={effectiveDate}
                      onChange={(date) => {
                        setEffectiveDate(date)
                        if (date) {
                          validateEffectiveDate(date)
                        }
                      }}
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                      allowClear
                      inputReadOnly={false}
                      disabledDate={disabledEffectiveDate}
                    />
                    {effectiveDateError && (
                      <small style={{ color: "red", display: "block", marginTop: "5px" }}>
                        {effectiveDateError}
                      </small>
                    )}
                  </div>
                  <div className="input-blocks">
                    <label className="form-label">Description (Optional)</label>
                    <TextArea
                      size="large"
                      placeholder="Desription"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="input-blocks">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio1"
                        defaultValue="oneTime"
                        checked={paymentTyep === "oneTime"}
                        onChange={(e) => onchangePaymentType(e)}
                      />

                      <label className="form-check-label" htmlFor="inlineRadio1">
                        One Time
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio2"
                        defaultValue="recurring"
                        checked={paymentTyep === "recurring"}
                        onChange={onchangePaymentType}
                      />

                      <label className="form-check-label" htmlFor="inlineRadio2">
                        Recurring
                      </label>
                    </div>
                  </div>
                  {paymentTyep === "oneTime" && (
                    <div className="input-blocks">
                      <div 
                        style={{ 
                          backgroundColor: "#f0f8ff", 
                          padding: "10px", 
                          borderRadius: "5px",
                          border: "1px solid #d1e7fd"
                        }}
                      >
                        <small style={{ color: "#0c5460", fontStyle: "italic" }}>
                          <strong>Note:</strong> For one-time deductions, the installment is automatically set to one month with the full amount.
                        </small>
                      </div>
                    </div>
                  )}
                  {paymentTyep === "recurring" && (
                    <>
                      <div className="input-blocks">
                        <label className="form-label">
                          Start Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <DatePicker
                          size="large"
                          value={startDate}
                          placeholder="Start Date"
                          onChange={handleDateStart}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="input-blocks">
                        <label className="form-label">
                          End Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <DatePicker
                          size="large"
                          placeholder="End Date"
                          value={endDate}
                          onChange={(date) => {
                            handleDateEnd(date)
                            if (startDate && date) {
                              validateDateRange()
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="input-blocks">
                        <label className="form-label">
                          Number of Installments (Months) <span style={{ color: "red" }}>*</span>
                        </label>
                        <Input
                          size="large"
                          type="number"
                          min="1"
                          placeholder="Number of months"
                          value={paymentPeriod}
                          onChange={(e) => setPaymentPeriod(e.target.value)}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="input-blocks">
                        <label className="form-label">Installment Amount (Rs.)</label>
                        <Input
                          size="large"
                          placeholder="Auto-calculated"
                          value={installement}
                          readOnly
                          disabled
                          style={{ width: "100%", backgroundColor: "#f5f5f5" }}
                        />
                        <small style={{ color: "#666", display: "block", marginTop: "5px" }}>
                          Installment = Total Amount ÷ Number of Installments
                        </small>
                      </div>
                      {dateValidationError && (
                        <div className="input-blocks">
                          <small style={{ color: "red", display: "block" }}>
                            {dateValidationError}
                          </small>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "20px" }}>
                  <button
                    disabled={loading || loading2}
                    type="button"
                    className="btn btn-cancel"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                  <button
                    disabled={loading || loading2}
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSave}
                  >
                    {loading || loading2 ? <Spin size="small" /> : isEdit ? "Update" : "Save"}
                  </button>
                </div>
                {loading || loading2 ? (
                  <div className="spinner">
                    <div className="loading-circle"></div>
                  </div>
                ) : (
                  <div>{/* Render Data Here */}</div>
                )}
              </div>
            </div>
            <div className="col-9 col-dd">
              <div className="table-responsive">
                <Table
                  loading={loading2}
                  columns={columns}
                  rowKey="value"
                  dataSource={deductionList}
                  pagination={{
                    current: pagination.current,
                    pageSizeOptions: ["5", "10", "20", "50"],
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    position: ["bottomCenter"],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  // footer={() => (
                  //   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  //     <button className="btn btn-primary btn-sm" onClick={() => setPageSizeModalVisible(true)}>
                  //       Change Size
                  //     </button>
                  //   </div>
                  // )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>

      <BulkUploadModal
        handleCancel={() => setIsBulkUploadOpen(false)}
        isVisible={isBulkUploadOpen}
        onUploadData={fetchData}
      />
    </div>
  )
}

export default Deduction

